import { Autocomplete, TextField } from '@mui/material';
import React, { useState } from 'react'
import { useEffect } from 'react';

import { useRef } from 'react';

export default function PrinterList({ value, width, list, onChangeValue, selectedValue, onClick, show, onClickList, placeholder, blackClass, sendPrinters, label }) {

    const [data, setData] = useState(list);
    const [inputVal, setInputVal] = useState('');
    const [DevicesFilters, setDevicesFilter] = useState([]);
    const [Devices, setDevices] = useState([]);
    const [visible, setVisible] = useState(false)
    const num = [1232, 5165, 615498, 65165, 1232, 5165, 615498, 65165, 1232, 5165, 615498, 65165, 1232, 5165, 615498, 65165] 
    function useOutsideAlerter(ref) {
        useEffect(() => {
            /**
             * Alert if clicked on outside of element
             */
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    // alert("You clicked outside of me!");
                    setVisible(false)
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);

    const listData = (data) => {
        onClickList(data)
        setInputVal(data?.name || '')
    }

    // Keep input text in sync with parent value (so it can be cleared/reset)
    useEffect(() => {
        setInputVal(value || '');
    }, [value]);
    useEffect(() => {
        window.BrowserPrint.getLocalDevices(function (deviceList) {
                if (deviceList && deviceList.printer) {
                    setDevices(deviceList.printer);
                    setDevicesFilter(deviceList.printer);
                } else {
                    setDevices([]);
                    setDevicesFilter([]); 
                }
            },
            (err) => {
                console.error("Error fetching devices:", err);
                setDevices([]);
                setDevicesFilter([]); 
            }
        );
    }, []);

    return (
        <Autocomplete
            style={{ marginTop: '20px' }}
            disablePortal
            id="printer"
            size={'small'}
            options={DevicesFilters || []}
            getOptionLabel={(option) => option?.name || ''}
            onChange={(e, v) => listData(v === null ? null : v)}
            value={(DevicesFilters || []).find((d) => d?.name === value) || null}
            inputValue={inputVal}
            onInputChange={(e, v) => setInputVal(v)}
            sx={{ width: "100%" }}
            renderInput={(params) => (
                <TextField
                {...params} label={label ?? "Printer"}
                    placeholder={placeholder} 
                />
            )}
        />
    )
}
